import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

let config: RouteRecordRaw[] = []

const ignoreRoute: any[] = ['/login', '/non-privilege', '/confirm-account'];

const files = require.context('.', false, /^((?!index).)*.ts$/, 'sync');

files.keys().forEach((fileName) => {
	const dummy = files(fileName);
	const router = dummy.default || dummy;
	config = config.concat(router);
});

const routes: Array<RouteRecordRaw> = [
    // {
    //   path: "/",
    //   name: "home",
    //   component: HomeView,
    // },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    },
    
    {
        path: "/:id",
        name: "gis_id",
        component: () => import(/* webpackChunkName: "about" */ "@/pages/gis/gis.vue"),
    },

    {
        path: "/",
        name: "gis",
        // props: route => ({ query: route.query.id }),
        component: () => import(/* webpackChunkName: "about" */ "@/pages/gis/gis.vue"),
    },

    {
        path: "/map",
        name: "map",
        component: () => import(/* webpackChunkName: "about" */ "@/pages/map/map.vue"),
    },
];

const router = createRouter({
    history: createWebHistory('/ban-do'),
    routes,
});
router.beforeEach(async (to, from, next) => {
	next();
});

export default router;

